export default "__VITE_ASSET__bf14c390__"